import { ComandiEnabledResponse } from "@/types/comandiEnabled";
import { defineStore } from "pinia";
import { ref } from "vue";

// Da verificare tipizzazione
export const useComandiEnabled = defineStore("comandiEnabled", () => {
  const comandiEnabled = ref<ComandiEnabledResponse[]>([]);

  const setComandiEnabled = (value: ComandiEnabledResponse[] | null) => {
    comandiEnabled.value = value ? [...value] : [];
  };

  const isEnabled = (fnName: string) => {
    return comandiEnabled.value.some(campoEnabled => {
      return campoEnabled.nc === fnName;
    });
  };

  return {
    isEnabled,
    comandiEnabled,
    setComandiEnabled,
  };
});
